// Bring in the imports from the feathers-client.js file.
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../feathers-client'

// Extend the base class
class Publisher extends BaseModel {
  // constructor (data, options) {
  //   super(data, options)
  // }
  static modelName = 'Publisher'
  static instanceDefaults () {
    return {
      topic: '',
      message: ''
    }
  }
}
const servicePath = 'publisher'
const servicePlugin = makeServicePlugin({
  Model: Publisher,
  service: feathersClient.service(servicePath),
  servicePath
})

// Optionally add service-level hooks, here:
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
